import { api } from "@/comn";
import { comnUtils } from "@/comn/utils";
import { TFormSchema, TGridSchema, useTheme } from "@/comn/hooks";
import { ptlEnvs } from "@/tz/go/egaz/osci/ptl/comn";

/*
 *  Organization Department Management Services
 * !== 기관 부서 관리 서비스 ==!
 */

export const BASE = {
    path: `${ptlEnvs.base}/usr/orgdept`,
    api: `${process.env.REACT_APP_API_PTL_COMN}/api/v1/osci/ptl/usr/orgdept/org-dept-mgmt`,
    nodes: [],
};

export const URLS = {
    osci0103009q: `${BASE.path}/osci0103009q`, // Organizations Department List !==  기관 부서 목록 ==!
};

export const APIS = {
    // Check Organizations Department List !== 기관 부서 목록 조회 ==!
    getOrgDeptList: (data: any) => {
        return api.get(`${BASE.api}/${data.orgCd}`);
    },

    // Organizations Department details inquiry !== 기관 부서 상세 정보 조회 ==!
    getOrgDeptInfo: (data: any) => {
        return api.get(`${BASE.api}/${data.orgCd}/${data.deptCd}`);
    },
    // Create Organization Department !== 기관 부서 등록 ==!
    createOrgDept: (data: any) => {
        return api.post(`${BASE.api}`, {
            ...data,
        });
    },
    // Update Organization Department !==  기관 부서 수정 ==!
    updateOrgDept: (data: any) => {
        return api.put(`${BASE.api}/${data.orgCd}/${data.deptCd}`, {
            ...data,
        });
    },
    // Delete Organization Department !== 기관 부서 삭제 ==!
    deleteOrgDept: (data: any) => {
        return api.delete(`${BASE.api}/${data.orgCd}/${data.deptCd}`);
    },
};

export const SF_ORG_DEPT_SRCH: TFormSchema = {
    id: "form_orgzSrch",
    schema: {
        orgCd: {
            type: "code",
            label: "L_ORG_CD",
            area: "orgCd",
            popupSize: "md",
            required: true,
        },
        langCd: { type: "text", label: "L_LANG_CD" },
    },
};

export const SG_SCTN_LIST: TGridSchema = {
    id: "grid_sctnList",
    options: { pagination: "out", index: true },
    head: [
        { cells: [{ header: "L_CSTM_SCTN_CD", binding: "cstmSctnCd", width: 150 }] },
        { cells: [{ header: "L_CSTM_SCTN_NM", binding: "cstmSctnNm", width: "*" }] },
        // { cells: [{ header: "L_CSTM_OFCE_CD", binding: "cstmOfceCd", width: 150 }] },
    ],
    body: [
        {
            cells: [{ binding: "cstmSctnCd" }],
        },
        {
            cells: [{ binding: "cstmSctnNm" }],
        },
    ],
};

export const SF_ORG_DEPT_INFO: TFormSchema = {
    id: "form_orgzInfo",
    schema: {
        deptCd: {
            type: "text",
            label: "L_DEPT_CD",
            placeholder: "automatically generated",
            labelSize: 3,
            readOnly: true,
        },
        uprDeptCd: {
            type: "code",
            area: "orgDeptCd",
            label: "L_UPR_DEPT_CD",
            popupSize: "md",
            labelSize: 3,
        },
        deptNm: { type: "text", label: "L_DEPT_NM", required: true, labelSize: 3, maxLength: 150 },
        deptDesc: { type: "text", label: "L_DEPT_DESC", required: true, labelSize: 3, maxLength: 2000 },
        deptIdtnOrd: {
            type: "text",
            label: "L_DEPT_IDTN_ORD",
            required: true,
            labelSize: 3,
            maxLength: 3,
            pattern: { value: /^[0-9]{1,3}$/, message: "msg.osc.00188" },
        },
        useYn: {
            required: true,
            type: "radio",
            label: "L_USE_YN",
            options: [
                { label: "Y", value: "Y" },
                { label: "N", value: "N" },
            ],
            defaultValue: "Y",
            labelSize: 3,
        },

        newYn: { type: "boolean", label: "L_NEW_YN", labelSize: 3 },
    },
};
